import { useRef, useEffect } from 'react';
const useInputFocusLock = (shouldFocus) => {
    const ref = useRef(null);
    useEffect(() => {
        shouldFocus && ref.current.focus();
    });
    return ref;
};
export default useInputFocusLock;
//# sourceMappingURL=index.js.map